// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".share-tags-cont body[data-theme=night] .offer-type-button{background:var(--gray)}", ""]);
// Exports
module.exports = exports;
